import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ZenDialogMsgService } from '../../../zentility/_shared/_services/zen-dialog-msg.service';
import { SharedModule } from '../../../zentility/_shared/shared.module';
import { JenZenImgType } from '../../../zentility/_shared/_components/jen-zen-img/jen-zen-img.component';


@Component({
  selector: 'app-upload-zone',
  standalone: true,
  imports: [SharedModule],
  template: `
    <div
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        class="upload-zone"
        [class.compact]="hasFiles"
        [class.dragging]="isDragging"
    >
        <input
            type="file"
            multiple
            accept="application/pdf"
            (change)="handleFileInput($event)"
            class="file-input"
        />
        <div class="upload-content" [class.scale-up]="!hasFiles">
            <div class="upload-icon" [class.large]="!hasFiles" [class.jen-zen]="!hasFiles">
                @if (!hasFiles) {
                    <app-jen-zen-img [imgType]="JenZenImgType.HAPPY"></app-jen-zen-img>
                } @else {
                    <i class="material-symbols-rounded">cloud_upload</i>
                }
            </div>
            <div class="upload-text">
                <p class="upload-title" [class.large]="!hasFiles">
                    {{ isDragging ? "Drop PDF files here" : "Upload Energy Bills" }}
                </p>
                <p class="upload-subtitle" [class.large]="!hasFiles">
                    {{ hasFiles
                        ? "Drag & drop or click to browse"
                        : "Drag & drop your PDF electricity and natural gas bills here to automatically process them with AI and build your portfolio."
                    }}
                </p>
            </div>
        </div>
    </div>
  `,
  styleUrl: './upload-zone.component.scss'
})
export class UploadZoneComponent {
    @Input() hasFiles = false;
    @Output() filesSelected = new EventEmitter<File[]>();

    isDragging = false;
    JenZenImgType = JenZenImgType;

    constructor(private zenDialogSvc: ZenDialogMsgService) {}

    onDragOver(e: DragEvent) {
        e.preventDefault();
        this.isDragging = true;
    }

    onDragLeave(e: DragEvent) {
        e.preventDefault();
        this.isDragging = false;
    }

    onDrop(e: DragEvent) {
        e.preventDefault();
        this.isDragging = false;
        if (e.dataTransfer?.files) {
            this.emitFiles(e.dataTransfer.files);
        }
    }

    handleFileInput(e: Event) {
        const input = e.target as HTMLInputElement;
        if (input.files) {
            this.emitFiles(input.files);
            input.value = ''; // Reset
        }
    }

    private emitFiles(fileList: FileList) {
        const files = Array.from(fileList).filter(f => f.type === 'application/pdf');
        if (files.length > 0) {
            this.filesSelected.emit(files);
        } else {
             // Handle error/notification about non-PDFs if needed
             this.zenDialogSvc.openToast(false, "Only PDF files are supported.");
        }
    }
}
